import lightboxConstants    from './lightbox.constants';
import lightboxInitialState from './lightbox.state';

function lightboxReducer(state = lightboxInitialState, action) {
  switch (action.type) {
    case lightboxConstants.LIGHT_BOX_OPEN:
      state = {
        ...state,
        open:    true,
        slides:  action.slides,
        current: +action.current,
        loading: true,
      };
      break;

    case lightboxConstants.LIGHT_BOX_CLOSE:
      state = { ...lightboxInitialState };
      break;

    case lightboxConstants.LIGHT_BOX_NAVIGATE:
      state = {
        ...state,
        current: +action.slide,
        loading: true,
      };
      break;

    case lightboxConstants.LIGHT_BOX_LOADED:
      state = {
        ...state,
        loading: false,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default lightboxReducer;